import { ROLES } from "./user";

export const LANDING = '/';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/auth/login-page';
export const PASSWORD_FORGET = '/pw-forget';
export const ADMIN = '/admin/dashboard';
export const USER_PROFILE_PAGE = '/admin/user-page';
export const EDIT_USER_PROFILE_PAGE = '/admin/user-page';
